import React from 'react'

import HTMLViewer from '@/components/shared/components/HTMLViewer'
import Typography from '@/components/shared/ui/Typography'
import { useTranslations } from '@/hooks/useTranslations'
import { isHTMLContentEmpty } from '@/lib/helpers/stringHelpers'
import type { IKanbanItem } from '@/types/roadmap'

interface IPropTypes {
  kanbanItem: IKanbanItem
}
export default function KanbanEntryItemPreview({ kanbanItem }: IPropTypes) {
  const t = useTranslations('roadmap.kanban.addNewEntry')
  return (
    <div className='space-y-4'>
      {kanbanItem.header_image && (
        <img
          src={kanbanItem.header_image?.toString()}
          alt={kanbanItem.title}
          className='h-40 w-full rounded !object-none'
        />
      )}
      <Typography.Title level={3}>{kanbanItem.title}</Typography.Title>
      <Typography.Text className='py-2'>{kanbanItem.two_liner}</Typography.Text>
      {!isHTMLContentEmpty(kanbanItem.description) && (
        <div>
          <span className='pb-3 text-base font-medium'>
            {t('fields.description.label')}
          </span>
          <HTMLViewer html={kanbanItem.description || ''} />
        </div>
      )}
    </div>
  )
}
